<template>
  <div class="create-account-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card mt-5">
            <div class="card-header text-center">
              <h2>Create New Account - ISACI</h2>
            </div>
            <div class="card-body">
              <!-- 步骤指示器 -->
              <div class="steps-indicator mb-4">
                <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
                  <div class="step-number">1</div>
                  <div class="step-label">Email verification</div>
                </div>
                <div class="step-line"></div>
                <div class="step" :class="{ active: currentStep === 2, completed: currentStep > 2 }">
                  <div class="step-number">2</div>
                  <div class="step-label">Fill in the information</div>
                </div>
              </div>

              <!-- 步骤1：邮箱验证 -->
              <div v-if="currentStep === 1" class="step-content">
               
                
                <form @submit.prevent="verifyEmail">
                  <div class="form-group">
                    <label for="username">Email Address *</label>
                    <input 
                      type="email"
                      class="form-control" 
                      id="username" 
                      v-model="emailForm.username"
                      required
                      :disabled="emailChecking"
                      title="Please enter your email address"
                    >
                    <small class="form-text text-muted">This will be your username for login</small>
                  </div>
                  
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-lg btn-block" :disabled="emailChecking">
                      {{ emailChecking ? 'loading...' : 'Continue' }}
                    </button>
                  </div>
                  
                  <div class="text-center mt-3">
                    <p>Already have an account? <router-link to="/login">Log in here</router-link></p>
                  </div>
                </form>
              </div>

              <!-- 步骤2：填写注册信息 -->
              <div v-if="currentStep === 2" class="step-content">
                <div class="text-center mb-4">
                  <p class="text-muted">Email <strong>{{ emailForm.username }}</strong> is available, please fill in your personal information</p>
                </div>
                
                <form @submit.prevent="createAccount">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="first_name">First Name *</label>
                        <input 
                          type="text" 
                          class="form-control" 
                          id="first_name" 
                          v-model="form.first_name"
                          required
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="last_name">Last Name *</label>
                        <input 
                          type="text" 
                          class="form-control" 
                          id="last_name" 
                          v-model="form.last_name"
                          required
                        >
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group">
                    <label for="organization">Organization/Institution *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="organization" 
                      v-model="form.organization"
                      required
                    >
                  </div>
                  
                  <div class="form-group">
                    <label for="country">Country *</label>
                    <CountrySelect v-model="form.country" required />
                  </div>
                  
                  <div class="form-group">
                    <label for="telephone">telephone Number</label>
                    <input 
                      type="tel" 
                      class="form-control" 
                      id="telephone" 
                      v-model="form.telephone"
                    >
                  </div>
                  
                  <div class="form-group">
                    <label for="title">Title *</label>
                    <select class="form-control" id="title" v-model="form.title" required>
                      <option value="">--SELECT--</option>
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                      <option value="Dr">Dr</option>
                      <option value="Prof">Prof</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="birth_year">Birth Year</label>
                    <input type="number" class="form-control" id="birth_year" v-model="form.birth_year" min="1901" max="2010" placeholder="e.g. 1990">
                  </div>
                  <div class="form-group">
                    <label for="gender">Gender *</label>
                    <GenderSelect v-model="form.gender" required />
                  </div> 
                  <div class="form-group">
                    <label for="job_title">Job Title *</label>
                    <JobTitleSelect v-model="form.job_title" @change="onJobTitleChange" required />
                  </div>
                  <div class="form-group" v-if="form.job_title === 'Others'">
                    <label>Please specify:</label>
                    <input class="form-control" type="text" v-model="form.jobTitleOther">
                  </div>
                  
                  <div class="form-group">
                    <label for="password">Password *</label>
                    <input 
                      type="password" 
                      class="form-control" 
                      id="password" 
                      v-model="form.password"
                      required
                    >
                    <small class="form-text text-muted">Password must be at least 8 characters long</small>
                  </div>
                  
                  <div class="form-group">
                    <label for="confirmPassword">Confirm Password *</label>
                    <input 
                      type="password" 
                      class="form-control" 
                      id="confirmPassword" 
                      v-model="form.confirmPassword"
                      required
                    >
                  </div>
                  
                  <div class="form-group form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="agreeTerms"
                      v-model="form.agreeTerms"
                      required
                    >
                    <label class="form-check-label" for="agreeTerms">
                      I agree to the <a href="#" target="_blank">Terms of Service</a> and <a href="#" target="_blank">Privacy Policy</a> *
                    </label>
                  </div>
                  
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-lg btn-block" :disabled="loading">
                      {{ loading ? 'Creating Account...' : 'Create Account' }}
                    </button>
                  </div>
                  
                  <div class="text-center mt-3">
                    <button type="button" class="btn btn-link" @click="goBackToStep1">
                      Back to Email Verification
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from '@/config/api'
import CountrySelect from '@/components/CountrySelect.vue'
import GenderSelect from '@/components/GenderSelect.vue'
import JobTitleSelect from '@/components/JobTitleSelect.vue'

export default {
  name: 'CreateAccount',
  components: {
    CountrySelect,
    GenderSelect,
    JobTitleSelect
  },
  data() {
    return {
      currentStep: 1,
      emailChecking: false,
      emailForm: {
        username: ''
      },
      form: {
        first_name: '',
        last_name: '',
        username: '',
        organization: '',
        country: '',
        telephone: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false,
        title: '',
        birth_year: '',
        gender: '',
        job_title: '',
        jobTitleOther: ''
      },
      loading: false
    }
  },
  methods: {
    async verifyEmail() {
      if (!this.emailForm.username) {
        alert('Please enter your email address')
        return
      }
      // 本地正则校验邮箱格式
      const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      if (!emailPattern.test(this.emailForm.username)) {
        alert('Invalid email format')
        return
      }
      this.emailChecking = true
      try {
        // 调用邮箱验证接口
        const response = await apiService.auth.checkEmail(this.emailForm.username)
        if (response.data.data == null ) {
          // 邮箱可用，进入下一步
          this.form.username = this.emailForm.username
          this.currentStep = 2
        } else {
          alert(response.data.message || 'This email has already been registered, please use another email or log in directly')
        }
      } catch (error) {
        if (error.response?.status === 409) {
          alert('This email has already been registered, please use another email or log in directly')
        } else if (error.response?.status === 400) {
          alert('Invalid email format')
        } else {
          alert('Email verification failed, please try again later')
        }
      } finally {
        this.emailChecking = false
      }
    },
    
    goBackToStep1() {
      this.currentStep = 1
    },
    
    onJobTitleChange() {
      if (this.form.job_title !== 'Others') {
        this.form.jobTitleOther = ''
      }
    },
    
    async createAccount() {
      if (this.form.password !== this.form.confirmPassword) {
        alert('Passwords do not match')
        return
      }
      if (this.form.password.length < 8) {
        alert('Password must be at least 8 characters')
        return
      }
      // 必填项校验
      const genderMissing = this.form.gender === '' || this.form.gender === null || this.form.gender === undefined
      if (!this.form.first_name || !this.form.last_name || !this.form.title || genderMissing || !this.form.job_title) {
        alert('Please fill in all required fields')
        return
      }
      this.loading = true
      try {
        // 组装最终提交数据
        const submitData = { ...this.form }
        if (this.form.job_title === 'Others') {
          submitData.job_title = this.form.jobTitleOther
        }
        // 调用注册接口
        const response = await apiService.auth.register(submitData)
        if (response.data.code) {
          alert('Account created successfully! Please log in with your email and password.')
          this.$router.push('/login')
        } else {
          alert(response.data.message || 'Account creation failed, please try again')
        }
      } catch (error) {
        if (error.response?.status === 409) {
          alert('This email has already been registered')
        } else if (error.response?.status === 400) {
          alert('Please check if the information entered is correct')
        } else {
          alert('Account creation failed, please try again later')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.create-account-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px 0;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.btn-block {
  width: 100%;
}

.form-group {
  margin-bottom: 1rem;
}

.form-check-label a {
  color: #3498DB;
  text-decoration: none;
}

.form-check-label a:hover {
  text-decoration: underline;
}

/* 步骤指示器样式 */
.steps-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
}

.step.active .step-number {
  background-color: #3498DB;
  color: white;
}

.step.completed .step-number {
  background-color: #28a745;
  color: white;
}

.step-label {
  font-size: 0.9rem;
  color: #6c757d;
  text-align: center;
}

.step.active .step-label {
  color: #3498DB;
  font-weight: bold;
}

.step.completed .step-label {
  color: #28a745;
  font-weight: bold;
}

.step-line {
  width: 100px;
  height: 2px;
  background-color: #e9ecef;
  margin: 0 1rem;
  margin-top: -1rem;
}

.step-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 